import { registerPlugin } from '@capacitor/core';
const Updater = registerPlugin('Updater', {
    web: () => import('./web').then(m => new m.UpdaterWeb()),
});
export * from './definitions';
export { Updater };
//# sourceMappingURL=index.js.map